import React from "react";

const DTOGovtTaxARModal = () => {
  return <></>;
};

export default DTOGovtTaxARModal;
